import { render, staticRenderFns } from "./CustomNavLink.vue?vue&type=template&id=6682ebe0&scoped=true"
import script from "./CustomNavLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomNavLink.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CustomNavLink.vue?vue&type=style&index=0&id=6682ebe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6682ebe0",
  null
  
)

export default component.exports